/** 배송(택배) 포털 상품 이미지 CDN */
const PARCEL_IMAGE_CDN_BASE = "https://cdnfile.koreaboardgames.com";

export function parcelCdnImageUrl(path: string): string {
  return `${PARCEL_IMAGE_CDN_BASE}/${path.trim()}`;
}
